// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/dist/cjs.js??ref--6-oneOf-3-1!../../../../postcss-loader/src/index.js??ref--6-oneOf-3-2!../../../../postcss-loader/src/index.js??ref--6-oneOf-3-3!./choices.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("82a6cf64", content, true, {"sourceMap":false,"shadowMode":false});